import React, { useState, useEffect, useMemo } from 'react';
import { Autocomplete, TextField, Table, TableBody, TableCell, TableContainer, Box, CircularProgress, TableHead, TableRow, Paper, Button, TablePagination, Checkbox, Grid, Modal } from '@mui/material';
import GestionCotizaciones from './GestionCotizacion'; // Asegúrate de que la ruta sea correcta
import GestionOrdenTrabajo from './GestionOrdenTrabajo';
import Swal from 'sweetalert2';
import GestionFactura from './GestionFactura'; // Ajusta la ruta si es necesario
import dayjs from 'dayjs';
import Resultados from './Resultados';
import { useSucursal } from '../contexts/SucursalContext';
import { useUser } from '../contexts/UserContext';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { faMobileAlt, faEnvelope, faPrint } from '@fortawesome/free-solid-svg-icons';
import TomaMuestra from '../Analisis/TomaMuestra';
import { useAccesos } from '../contexts/AccesosContext';

const swalWithHighZIndex = Swal.mixin({
    zIndex: 9999
});

function OrdenesTrabajoHospital() {
    const { tienePermiso } = useAccesos();
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [ordenesTrabajo, setOrdenesTrabajo] = useState([]);
    const [totalOrdenesTrabajo, setTotalOrdenesTrabajo] = useState(0);
    const [searchQuery, setSearchQuery] = useState('');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [selectedOrdenTrabajo, setSelectedOrdenTrabajo] = useState(null);

    const [openModal, setOpenModal] = useState(false);
    const [ordenTrabajoData, setOrdenTrabajoData] = useState(null);
    const [detallesOrdenTrabajo, setDetallesOrdenTrabajo] = useState([]);
    const [detallesOrdenTrabajoInfo, setDetallesOrdenTrabajoInfo] = useState([]);
    const [openFacturaModal, setOpenFacturaModal] = useState(false);
    const [facturaData, setFacturaData] = useState(null);
    const [detalleSeleccionado, setDetalleSeleccionado] = useState(null);
    const [loading, setLoading] = useState(false);    const [sucursales, setSucursales] = useState([]);
    const { sucursalSeleccionada, cajaAbierta } = useSucursal();
    const [sucursalFiltro, setSucursalFiltro] = useState(null);
    const [fechaInicio, setFechaInicio] = useState('');
    const [fechaFin, setFechaFin] = useState('');
    const [openResultadosModal, setOpenResultadosModal] = useState(false);
    const [numericCodigo, setNumericCodigo] = useState(null);
    const [selectedModulo, setSelectedModulo] = useState(null); // Nuevo estado para Módulo
    const [modulos, setModulos] = useState([]); // Estado para guardar los módulos obtenidos
    const { user } = useUser();
    const [selectedDetalles, setSelectedDetalles] = useState([]);
    const [openTomaMuestra, setOpenTomaMuestra] = useState(false);
    const [selectedAnalisisIdForToma, setSelectedAnalisisIdForToma] = useState(null);

    // useEffect para obtener los módulos (ejemplo: módulos de tipo 1)
    useEffect(() => {
        const fetchModulos = async () => {
            try {
                const response = await fetch(`${server}/MgModuloes/porIdTipo/1`);
                if (response.ok) {
                    const data = await response.json();
                    setModulos(data.$values || []);
                    console.log(data.$values);
                } else {
                    console.error("Error al obtener modulos");
                }
            } catch (error) {
                console.error("Error al obtener modulos:", error);
            }
        };
        fetchModulos();
    }, [server]);

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            handleSearch();
        }
    };
    // Función para cargar ordenes de trabajo desde la API con paginación y búsqueda
    // --- OBTENER ORDENES DE TRABAJO ---
    // Podrás pasar manualmente fechaInicio y fechaFin para la primera carga
    const fetchOrdenesTrabajos = async (
        search = '',
        fi = fechaInicio,
        ff = fechaFin
    ) => {
        try {
            setLoading(true);
            const bodyData = {
                page: 1,
                limit: 100,
                search,
                idSucursal: sucursalFiltro ? sucursalFiltro.idSucursal : 0,
                fechaInicio: fi,
                fechaFin: ff,
                idModulo: selectedModulo ? selectedModulo.idModulo : "" // Se envía el idModulo seleccionado (o 0 si no se ha seleccionado)
            };
            console.log(bodyData);
            const response = await fetch(`${server}/MgOrdenesMedicas/Paginados`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(bodyData),
            });

            const data = await response.json();
            setOrdenesTrabajo(data.cotizaciones.$values || []);
            setTotalOrdenesTrabajo(data.total || 0);
        } catch (error) {
            console.error('Error al cargar las órdenes de trabajo:', error);
            setOrdenesTrabajo([]);
            setTotalOrdenesTrabajo(0);
        } finally {
            setLoading(false);
        }
    };

    // --- useEffect: Montaje ---
    useEffect(() => {
        // 1) Calculamos la fecha "actual" y "3 meses atrás"
        const now = new Date();
        const startDate = new Date();
        startDate.setMonth(startDate.getMonth() - 3);

        // 2) Calculamos "mañana": hoy más 1 día
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);

        // 3) Convertir las fechas a string en formato YYYY-MM-DD
        const defaultInicio = startDate.toISOString().split('T')[0];
        const defaultFin = tomorrow.toISOString().split('T')[0];

        // 4) Llamar a la API de sucursales
        fetchSucursales();

        // 5) Guardar en estado
        setFechaInicio(defaultInicio);
        setFechaFin(defaultFin);
        
        // 6) Inicializar sucursalFiltro con la sucursal de sesión
        if (sucursalSeleccionada) {
            setSucursalFiltro(sucursalSeleccionada);
        }
    }, []);

    // Cargar órdenes cuando cambia el filtro de sucursal
    useEffect(() => {
        if (sucursalFiltro && fechaInicio && fechaFin) {
            fetchOrdenesTrabajos('', fechaInicio, fechaFin);
        }
    }, [sucursalFiltro]);


    // --- OBTENER SUCURSALES ---
    const fetchSucursales = async () => {
        try {
            const response = await fetch(`${server}/MgSucursales`);
            const data = await response.json();
            const lista = data.$values || data;
            setSucursales(lista);
        } catch (error) {
            console.error('Error al obtener sucursales:', error);
        }
    };

    // --- MANEJADORES SUCURSAL / FECHA / BUSCAR ---
    const handleSucursalSeleccionada = (event, newValue) => {
        console.log('🔍 Cambio de filtro de sucursal (solo para esta pantalla):', newValue);
        setSucursalFiltro(newValue);
    };
    const handleFechaInicioChange = (e) => setFechaInicio(e.target.value);
    const handleFechaFinChange = (e) => setFechaFin(e.target.value);
    // Cargar más cotizaciones al cambiar de página
    // useEffect(() => {
    //     if (page * rowsPerPage >= ordenesTrabajo.length - rowsPerPage && hasMore && !isLoadingMore) {
    //         setIsLoadingMore(true);
    //         fetchOrdenesTrabajos(page, 100, searchQuery).then(() => setIsLoadingMore(false));
    //     }
    // }, [page]);

    // Manejar cambio en el campo de búsqueda
    const handleSearchChange = (event) => {
        setSearchQuery(event.target.value);
    };

    // Manejar búsqueda al hacer clic en el botón
    const handleSearch = () => {
        setPage(0);
        fetchOrdenesTrabajos(searchQuery, fechaInicio, fechaFin);
    };

    // Manejar cambio de página
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    // Manejar cambio en el número de filas por página
    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleSelectDetalle = (idDetalle) => {
        console.log(idDetalle);
        setDetalleSeleccionado(idDetalle);
    };


    // Manejar selección de una cotización
    const handleSelectOrdenTrabajo = async (ordenTrabajo) => {
        setSelectedOrdenTrabajo(ordenTrabajo);
        setDetalleSeleccionado(null); // Reiniciar selección de detalle
        console.log(ordenTrabajo);
        try {
            // Hacer la solicitud a la API para obtener los detalles
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/idOrdenTrabajo/${ordenTrabajo.idOrdenMedica}`);
            if (response.ok) {
                const data = await response.json();
                console.log(data);
                setDetallesOrdenTrabajo(data.$values || []);
            } else {
                console.error('Error al obtener los detalles de la orden de trabajo');
                setDetallesOrdenTrabajo([]);
            }

        } catch (error) {
            console.error('Error al obtener los detalles de la orden de trabajo:', error);
            setDetallesOrdenTrabajo([]);
        }

        try {
            const response2 = await fetch(`${server}/MgOrdenesMedicas/OrdenMedica/${ordenTrabajo.idOrdenMedicaMes}`);
            console.log(response2);
            if (response2.ok) {
                const data = await response2.json(); // Usar response2 en lugar de response
                console.log(data.detalle?.$values);
                setDetallesOrdenTrabajoInfo(data.detalle?.$values || []);
            } else {
                console.error('Error al obtener los detalles completos de la orden de trabajo');
                setDetallesOrdenTrabajoInfo([]);
            }
        } catch (error) {
            console.error('Error al obtener los detalles de la orden de trabajo:', error);
            setDetallesOrdenTrabajoInfo([]);
        }



    };    const handleFactura = async () => {
        // Validar que la caja esté abierta antes de facturar
        if (!cajaAbierta) {
            swalWithHighZIndex.fire({
                title: 'Error',
                text: 'No hay caja abierta. Por favor, inicie la caja antes de facturar.',
                icon: 'error',
                zIndex: 2000
            });
            return;
        }

        if (selectedOrdenTrabajo) {
            try {
                console.log(selectedOrdenTrabajo);
                // Paso 1: Obtener los datos completos de la orden de trabajo
                //                 const responseOrdenTrabajo = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`);
                //                 if (responseOrdenTrabajo.ok) {
                //                     const ordenTrabajoData = await responseOrdenTrabajo.json();
                // console.log(ordenTrabajoData);
                // Paso 2: Preparar los datos para pasar a GestionFactura
                setFacturaData({
                    ordenTrabajo: selectedOrdenTrabajo.idOrdenMedica,
                    nombreCliente: selectedOrdenTrabajo.nombreCompleto,
                    identidad: selectedOrdenTrabajo.Identidad,
                    valorPagar: selectedOrdenTrabajo.valorVenta,
                    idSucursal: selectedOrdenTrabajo.idSucursal,
                    idCliente: selectedOrdenTrabajo.idCliente
                    // Agrega otros campos necesarios
                });

                // Paso 3: Abrir el modal de factura
                setOpenFacturaModal(true);
                // } else {
                //     alert('Error al obtener los datos de la orden de trabajo.');
                // }
            } catch (error) {
                console.error('Error al obtener los datos de la orden de trabajo:', error);
                alert('Error al obtener los datos de la orden de trabajo.');
            }
        } else {
            Swal.fire({
                text: 'Debes seleccionar una orden de trabajo',
                icon: 'warning'
            })
            return;

        }
    };


    // Acciones con la cotización seleccionada
    const handleImprimir = async () => {
        if (selectedOrdenTrabajo) {
            try {
                ///api/MgOrdenesMedicas/ImprimirOrdenMedica/{idOrden}
                const response = await fetch(`${server}/MgOrdenesMedicas/ImprimirOrdenMedica/${selectedOrdenTrabajo.idOrdenMedica}`, {
                    method: 'POST',
                });

                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const newWindow = window.open(url, '_blank');
                    if (newWindow) {
                        newWindow.focus();
                    } else {
                        alert('Por favor, permite las ventanas emergentes para previsualizar el documento.');
                    }
                } else {
                    console.error('Error al imprimir la orden de trabajo');
                    alert('Hubo un error al imprimir la orden de trabajo.');
                }
            } catch (error) {
                console.error('Error al imprimir la orden de trabajo:', error);
                alert('Hubo un error al imprimir la orden de trabajo.');
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
        }
    };

    const handleImprimirSobre = async () => {
        if (selectedOrdenTrabajo) {
            try {
                ///api/MgOrdenesMedicas/ImprimirOrdenMedica/{idOrden}
                const response = await fetch(`${server}/MgOrdenesMedicas/ImprimirOrdenMedica/${selectedOrdenTrabajo.idOrdenMedica}`, {
                    method: 'POST',
                });

                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const newWindow = window.open(url, '_blank');
                    if (newWindow) {
                        newWindow.focus();
                    } else {
                        alert('Por favor, permite las ventanas emergentes para previsualizar el documento.');
                    }
                } else {
                    console.error('Error al imprimir la orden de trabajo');
                    alert('Hubo un error al imprimir la orden de trabajo.');
                }
            } catch (error) {
                console.error('Error al imprimir la orden de trabajo:', error);
                alert('Hubo un error al imprimir la orden de trabajo.');
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
        }
    };


    const handleVerCompleto = async () => {
        if (selectedOrdenTrabajo) {
            try {
                ///api/MgOrdenesMedicas/ImprimirOrdenMedica/{idOrden}
                const response = await fetch(`${server}/MgOrdenesMedicas/ImprimirOrdenMedica/${selectedOrdenTrabajo.idOrdenMedica}`, {
                    method: 'POST',
                });

                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const newWindow = window.open(url, '_blank');
                    if (newWindow) {
                        newWindow.focus();
                    } else {
                        alert('Por favor, permite las ventanas emergentes para previsualizar el documento.');
                    }
                } else {
                    console.error('Error al imprimir la orden de trabajo');
                    alert('Hubo un error al imprimir la orden de trabajo.');
                }
            } catch (error) {
                console.error('Error al imprimir la orden de trabajo:', error);
                alert('Hubo un error al imprimir la orden de trabajo.');
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
        }
    };




    const handleWhatsapp = async () => {
        if (selectedOrdenTrabajo) {
            const { value: numeroWhatsapp } = await Swal.fire({
                title: 'Ingrese el número de WhatsApp',
                input: 'text',
                inputLabel: 'Número de WhatsApp',
                inputPlaceholder: '+50433333333',
                showCancelButton: true,
                inputValidator: (value) => {
                    if (!value) {
                        return 'Por favor ingrese un número de WhatsApp';
                    }
                    // Validar que el número de WhatsApp tenga un formato adecuado
                    const whatsappRegex = /^\+?[0-9]{1,4}[0-9]{10,15}$/;
                    if (!whatsappRegex.test(value)) {
                        return 'Por favor ingrese un número de WhatsApp válido, incluyendo el código de área si es necesario';
                    }
                }
            });

            if (numeroWhatsapp) {
                try {
                    const response = await fetch(`${server}/Whatsapp/PostOrdentoWhatsapp?idOrden=${selectedOrdenTrabajo.idOrdenMedica}&numeroWhatsapp=${numeroWhatsapp}`, {
                        method: 'POST',
                    });

                    if (response.ok) {
                        Swal.fire({
                            icon: 'success',
                            title: 'WhatsApp Enviado',
                            showConfirmButton: false,
                            timer: 1500
                        });
                    } else {
                        const errorData = await response.json();
                        const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                        Swal.fire({
                            icon: 'error',
                            title: `Error ${response.status}`,
                            text: errorMessage,
                        });
                    }
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error al enviar el WhatsApp',
                        text: error || 'Ocurrió un error inesperado',
                    });
                }
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
        }
    };
    const handleModificar = async () => {
        console.log(selectedOrdenTrabajo);
        if (selectedOrdenTrabajo) {
            try {
                // Paso 1: Obtener la cotización seleccionada
                const responseOrdenCompra = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`);
                const OrdenTrabajo = await responseOrdenCompra.json();

                console.log(OrdenTrabajo);

                // Paso 2: Obtener los detalles de la cotización (analisisAgregados)
                // const responseDetalles = await fetch(`${server}/CtzCotizacionesDetalles/porIdCotizacion/${selectedCotizacion.idCotizacion}`);
                // const detalles = await responseDetalles.json();

                // console.log(detalles.$values);
                // Paso 3: Preparar los datos para pasar al componente GestionCotizaciones
                setOrdenTrabajoData({
                    OrdenTrabajo: OrdenTrabajo,
                    modo: 'modificar',
                    // detalles: detalles.$values || [], // Asegurarse de que sea un array
                });

                // Paso 4: Abrir el modal
                setOpenModal(true);

            } catch (error) {
                console.error('Error al obtener la orden de trabajo:', error);
                alert('Hubo un error al obtener la orden de trabajo.');
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
            return;
        }
    };


    const handleDividir = async () => {
        if (selectedOrdenTrabajo) {
            try {
                // Obtener los datos completos de la orden de trabajo seleccionada
                const responseOrdenTrabajo = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`);
                const ordenTrabajoData = await responseOrdenTrabajo.json();

                // Preparar los datos para pasar al componente GestionOrdenTrabajo
                setOrdenTrabajoData({
                    OrdenTrabajo: ordenTrabajoData,
                    modo: 'dividir', // Indicamos que estamos en modo "dividir"
                });

                // Abrir el modal
                setOpenModal(true);
            } catch (error) {
                console.error('Error al obtener la orden de trabajo:', error);
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Hubo un error al obtener la orden de trabajo.',
                });
            }
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning',
            });
            return;
        }
    };


    const handleCrearOrden = () => {
        if (selectedOrdenTrabajo) {
            console.log('Crear orden de trabajo para la cotización:', selectedOrdenTrabajo);
            // Lógica para crear una orden de trabajo
        } else {
            alert('Por favor selecciona una cotización.');
        }
    };

    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '80%',
        maxHeight: '90vh',
        overflowY: 'auto',
        backgroundColor: '#fff',
        padding: '20px',
        boxShadow: 24,
        outline: 'none',
    };

    const paginatedOrdenesTrabajo = useMemo(() => {
        const start = page * rowsPerPage;
        const end = start + rowsPerPage;
        return ordenesTrabajo.slice(start, end);
    }, [ordenesTrabajo, page, rowsPerPage]);


    // Funciones manejadoras
    const handlePrevalidar = () => {

        if (!detalleSeleccionado) {
            Swal.fire({
                text: 'Por favor selecciona un examen.',
                icon: 'warning'
            })
            return;
        }

        Swal.fire({
            title: '¿Está seguro?',
            text: '¿Esta seguro de desea prevalidar este examen?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, Prevalidar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                ejecutarPrevalidar();
            }
        });
    };
    // Funciones manejadoras
    const handleImprimirAnalisis = async () => {

        try {
            if (!detalleSeleccionado) {
                Swal.fire({
                    text: 'Por favor selecciona un examen.',
                    icon: 'warning'
                })
                return;
            }
            else {


                ///api/MgOrdenesMedicas/ImprimirOrdenMedica/{idOrden}
                const response = await fetch(`${server}/MgAnalisisGeneralResultadosAnalitoes/ImprimirExamen/${detalleSeleccionado.idDetalle}`, {
                    method: 'POST',
                });
                console.log(detalleSeleccionado);
                if (response.ok) {
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const newWindow = window.open(url, '_blank');
                    if (newWindow) {
                        newWindow.focus();
                    } else {
                        alert('Por favor, permite las ventanas emergentes para previsualizar el documento.');
                    }
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });
                }

            }


        }
        catch (error) {
            console.error('Error al imprimir la orden de trabajo:', error);
            alert('Hubo un error al imprimir Examen.');
        }
    };

    // --- Funciones de validación para el detalle seleccionado ---

    function pickDetailFields(detail, fields) {
        return fields.reduce((acc, field) => {
            if (detail[field] !== undefined) {
                acc[field] = detail[field];
            }
            return acc;
        }, {});
    }

    const ejecutarPrevalidar = async () => {
        if (!detalleSeleccionado) return;

        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "idTipoAnalisis", "valorDescuento", "valorVenta", "evaluada", "comentarios"];



        const updateData = {
            ...pickDetailFields(detalleSeleccionado, camposDeseados),
            idTipoAprobacion: 1,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        console.log(updateData);
        try {
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalleSeleccionado.idDetalle}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updateData)
            });
            if (response.ok) {
                const histData = {
                    ingresadoPor: user ? user.codigoUsuario : "ADMIN",
                    aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                    fechaHoraAprobacion: new Date().toISOString().slice(0, -1),
                    idTipoAprobacion: 1,
                    idOrdenMedicaDetalle: detalleSeleccionado.idDetalle
                };
                console.log(histData);
                const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(histData)
                });
                if (histResponse.ok) {
                    Swal.fire("Prevalidado", "El detalle ha sido prevalidado.", "success");
                    setDetalleSeleccionado({ ...detalleSeleccionado, tipoValidacion: 1 });
                } else {
                    Swal.fire("Error", "No se pudo insertar en el histórico.", "error");
                }
            } else {
                Swal.fire("Error", "No se pudo actualizar el detalle.", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error al prevalidar.", "error");
        }
    };


    const ejecutarQuitarPrevalidar = async () => {
        if (!detalleSeleccionado) return;

        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "idTipoAnalisis", "valorDescuento", "valorVenta", "evaluada", "comentarios"];


        const updateData = {
            ...pickDetailFields(detalleSeleccionado, camposDeseados),
            idTipoAprobacion: null,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };
        try {
            const response = await fetch(`${server}/api/MgOrdenesMedicasDetalles/${detalleSeleccionado.idDetalle}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updateData)
            });
            if (response.ok) {
                const histData = {
                    ingresadoPor: user ? user.codigoUsuario : "ADMIN",
                    aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                    fechaHoraAprobacion: new Date().toISOString(),
                    idTipoAprobacion: null,
                    idOrdenMedicaDetalle: detalleSeleccionado.idDetalle
                };
                const histResponse = await fetch(`${server}/api/MgHistoricoValidaciones`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(histData)
                });
                if (histResponse.ok) {
                    Swal.fire("Quitado", "La prevalidación ha sido removida.", "success");
                    setDetalleSeleccionado({ ...detalleSeleccionado, tipoValidacion: null });
                } else {
                    Swal.fire("Error", "No se pudo insertar en el histórico.", "error");
                }
            } else {
                Swal.fire("Error", "No se pudo actualizar el detalle.", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error al quitar prevalidación.", "error");
        }
    };

    // Funciones manejadoras
    const handleQuitarPrevalidar = () => {

        if (!detalleSeleccionado) {

            Swal.fire('Por favor selecciona un examen.');
            return;
        }

        Swal.fire({
            title: '¿Está seguro?',
            text: '¿Esta seguro de desea anular la pre validacion de este examen?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, Prevalidar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                ejecutarQuitarPrevalidar();
            }
        });
    };


    const ejecutarValidar = async () => {
        if (!detalleSeleccionado) return;


        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "idTipoAnalisis", "valorDescuento", "valorVenta", "evaluada", "comentarios"];



        const updateData = {
            ...pickDetailFields(detalleSeleccionado, camposDeseados),
            idTipoAprobacion: 2,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        try {
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalleSeleccionado.idDetalle}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updateData)
            });

            if (response.ok) {

                const histData = {
                    ingresadoPor: user ? user.codigoUsuario : "ADMIN",
                    aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                    fechaHoraAprobacion: new Date().toISOString().slice(0, -1),
                    idTipoAprobacion: 2,
                    idOrdenMedicaDetalle: detalleSeleccionado.idDetalle
                };
                const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(histData)
                });
                if (histResponse.ok) {
                    Swal.fire("Validado", "El detalle ha sido validado.", "success");
                    setDetalleSeleccionado({ ...detalleSeleccionado, tipoValidacion: 2 });
                } else {
                    Swal.fire("Error", "No se pudo insertar en el histórico.", "error");
                }
            } else {
                Swal.fire("Error", "No se pudo actualizar el detalle.", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error al validar.", "error");
        }
    };

    const handleValidar = () => {

        // if (!detalleSeleccionado) {
        //     Swal.fire({
        //         text: 'Por favor selecciona un examen.',
        //         icon: 'warning'
        //     })
        //     return;

        // }

        Swal.fire({
            title: '¿Está seguro?',
            text: '¿Esta seguro de desea validar este examen?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, Validar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                handleValidarMultiple();
            }
        });
    };

    const ejecutarInvalidar = async () => {
        if (!detalleSeleccionado) return;

        const camposDeseados = [
            "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo",
            "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idPromocion", "idTipoAnalisis", "idTipoPrecio", "idTipoAnalisis", "valorDescuento", "valorVenta", "evaluada", "comentarios", "IngresadoPor"];


        // Volvemos a prevalidado (tipoValidacion = 1)
        const updateData = {
            ...pickDetailFields(detalleSeleccionado, camposDeseados),
            idTipoAprobacion: 1,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString(),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };
        try {
            const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalleSeleccionado.idDetalle}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(updateData)
            });
            if (response.ok) {
                const histData = {
                    ingresadoPor: user ? user.codigoUsuario : "ADMIN",
                    aprobadoPor: user ? user.codigoUsuario : "ADMIN",
                    fechaHoraAprobacion: new Date().toISOString(),
                    idTipoAprobacion: 1,
                    idOrdenMedicaDetalle: detalleSeleccionado.idDetalle
                };
                const histResponse = await fetch(`${server}/api/MgHistoricoValidaciones`, {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(histData)
                });
                if (histResponse.ok) {
                    Swal.fire("Invalidado", "El detalle se ha revertido a prevalidado.", "success");
                    setDetalleSeleccionado({ ...detalleSeleccionado, tipoValidacion: 1 });
                } else {
                    Swal.fire("Error", "No se pudo insertar en el histórico.", "error");
                }
            } else {
                Swal.fire("Error", "No se pudo actualizar el detalle.", "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Error al invalidar.", "error");
        }
    };



    const handleInvalidar = () => {
        if (!detalleSeleccionado) {
            Swal.fire('Por favor selecciona un examen.');
            return;
        }

        Swal.fire({
            title: '¿Está seguro?',
            text: '¿Esta seguro de desea invalidar este examen?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, Prevalidar',
            cancelButtonText: 'Cancelar',
        }).then((result) => {
            if (result.isConfirmed) {
                ejecutarInvalidar();
            }
        });
    };

    const handleResultados = () => {


        if (!selectedOrdenTrabajo) {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
            return;
        }


        Swal.fire({
            title: '¿Está seguro?',
            text: '¿Esta seguro que desea llenar los datos de los analisis de esta orden de trabajo?',
            showCancelButton: true,
            confirmButtonText: 'Sí',
            cancelButtonText: 'No',
        }).then((result) => {
            if (result.isConfirmed) {
                ejecutarResultados();
            }
        });
    };

    const ejecutarResultados = async () => {

        try {
            // Lógica para Prevalidar
            setNumericCodigo(selectedOrdenTrabajo); // Asigna el código de la orden seleccionada
            setOpenResultadosModal(true); // Abre el modal

        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Ocurrió un error al llenar los resultados de los examenes.',
            });
        }
    };


    // --- Funciones para "Atendida" ---
    const handleAtendida = () => {
        if (selectedOrdenTrabajo) {
            Swal.fire({
                title: '¿Está seguro?',
                text: '¿Desea marcar esta orden como Atendida?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Atendida',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    ejecutarAtendida();
                }
            });
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
            return;
        }
    };

    const ejecutarAtendida = async () => {
        try {

            const OrdeData = {
                ...selectedOrdenTrabajo,
                modificacion: 4,
                fechaModificacion: new Date().toISOString()
            }

            console.log(OrdeData);
            const response = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(OrdeData),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Orden marcada como Atendida',
                    showConfirmButton: false,
                    timer: 1500,
                });
                fetchOrdenesTrabajos(searchQuery);
            } else {
                const errorData = await response.json();
                const errorMessage =
                    errorData.message ||
                    (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al actualizar la orden de trabajo',
                text: error.message || 'Ocurrió un error inesperado',
            });
        }
    };

    // --- Funciones para "Anular" ---
    const handleAnular = () => {
        if (selectedOrdenTrabajo) {
            Swal.fire({
                title: '¿Está seguro?',
                text: '¿Desea anular esta orden de trabajo?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Anular',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    ejecutarAnular();
                }
            });
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
            return;
        }
    };

    const ejecutarAnular = async () => {
        try {
            const response = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...selectedOrdenTrabajo,
                    modificacion: 3,
                }),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Orden anulada exitosamente',
                    showConfirmButton: false,
                    timer: 1500,
                });
                fetchOrdenesTrabajos(searchQuery);
            } else {
                const errorData = await response.json();
                const errorMessage =
                    errorData.message ||
                    (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al anular la orden de trabajo',
                text: error.message || 'Ocurrió un error inesperado',
            });
        }
    };

    // --- Funciones para "Entregada" ---
    const handleEntregada = () => {
        if (selectedOrdenTrabajo) {
            Swal.fire({
                title: '¿Está seguro?',
                text: '¿Desea marcar esta orden como Entregada?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Sí, Entregada',
                cancelButtonText: 'Cancelar',
            }).then((result) => {
                if (result.isConfirmed) {
                    ejecutarEntregada();
                }
            });
        } else {
            Swal.fire({
                text: 'Por favor selecciona una orden de trabajo.',
                icon: 'warning'
            })
            return;
        }
    };

    const ejecutarEntregada = async () => {
        try {
            const response = await fetch(`${server}/MgOrdenesMedicas/${selectedOrdenTrabajo.idOrdenMedica}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    ...selectedOrdenTrabajo,
                    entregado: true,
                }),
            });

            if (response.ok) {
                Swal.fire({
                    icon: 'success',
                    title: 'Orden marcada como Entregada',
                    showConfirmButton: false,
                    timer: 1500,
                });
                fetchOrdenesTrabajos(searchQuery);
            } else {
                const errorData = await response.json();
                const errorMessage =
                    errorData.message ||
                    (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                Swal.fire({
                    icon: 'error',
                    title: `Error ${response.status}`,
                    text: errorMessage,
                });
            }
        } catch (error) {
            Swal.fire({
                icon: 'error',
                title: 'Error al actualizar la orden de trabajo',
                text: error.message || 'Ocurrió un error inesperado',
            });
        }
    };



    // 2. Función para alternar la selección de un detalle
    const toggleDetalleSelection = (detalle) => {
        console.log(detalle);
        setDetalleSeleccionado(detalle);
        setSelectedDetalles((prevSelected) => {
            // Si ya está seleccionado, lo quitamos; si no, lo agregamos
            const isSelected = prevSelected.some(d => d.idDetalle === detalle.idDetalle);
            if (isSelected) {
                return prevSelected.filter(d => d.idDetalle !== detalle.idDetalle);
            } else {
                return [...prevSelected, detalle];
            }
        });
    };

    // Función refactorizada para prevalidar un detalle individual
    const ejecutarPrevalidarDetalle = async (detalle) => {
        const camposDeseados = ["idDetalle", "descripcionTipoAnalisis", "valorVenta", "comentarios", "idEquipo", "ingresadoPor", "idFactura", "idMetodo", "idModulo", "idOrdenMedica", "idTipoAnalisis", "idTipoPrecio", "valorDescuento", "evaluada"];
        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 2,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };
        console.log(updateData);
        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData)
        });

        if (!response.ok) {
            throw new Error(`Error al prevalidar el detalle ${detalle.idDetalle}`);
        }

        // Insertar en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobacion: new Date().toISOString().slice(0, -1),
            idTipoAprobacion: 1,
            idOrdenMedicaDetalle: detalle.idDetalle
        };
        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData)
        });
        if (!histResponse.ok) {
            throw new Error(`Error al insertar en el histórico para el detalle ${detalle.idDetalle}`);
        }
        return updateData;
    };

    // Función para prevalidar múltiples detalles
    const handlePrevalidarMultiple = async () => {
        if (selectedDetalles.length === 0) {
            Swal.fire({ text: 'Por favor, selecciona al menos un examen.', icon: 'warning' });
            return;
        }

        // Verificamos si alguno está validado (2).
        const algunoValidado = selectedDetalles.some(d => d.idTipoAprobacion === 3);
        if (algunoValidado) {
            Swal.fire(
                "Error",
                "No se puede prevalidar: hay al menos un examen que ya está validado.",
                "error"
            );
            return;
        }


        Swal.fire({
            title: '¿Está seguro?',
            text: '¿Desea prevalidar los exámenes seleccionados?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, Prevalidar',
            cancelButtonText: 'Cancelar',
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await Promise.all(selectedDetalles.map(detalle => ejecutarPrevalidarDetalle(detalle)));
                    Swal.fire("Prevalidados", "Los detalles han sido prevalidados.", "success");
                    // Opcional: actualizar el estado para reflejar los cambios o limpiar la selección
                    await refreshDetalles();
                    setSelectedDetalles([]);
                } catch (error) {
                    console.error(error);
                    Swal.fire("Error", error.message, "error");
                }
            }
        });
    };

    const handleImprimirDetalles = async () => {
        if (selectedDetalles.length === 0) {
            Swal.fire({
                text: 'Por favor, selecciona al menos un detalle para imprimir.',
                icon: 'warning'
            });
            return;
        }

        try {
            // Recorrer cada detalle seleccionado y llamar a la API de impresión
            const printPromises = selectedDetalles.map(async (detalle) => {
                const response = await fetch(`${server}/MgAnalisisGeneralResultadosAnalitoes/ImprimirExamen/${detalle.idDetalle}`, {
                    method: 'POST',
                });
                if (!response.ok) {
                    throw new Error(`Error al imprimir el detalle con id ${detalle.idDetalle}`);
                }
                return response.blob();
            });

            // Esperar a que todas las solicitudes se resuelvan
            const blobs = await Promise.all(printPromises);

            // Para cada blob obtenido, se abre en una nueva ventana
            blobs.forEach((blob) => {
                const url = window.URL.createObjectURL(blob);
                window.open(url, '_blank');
            });

            Swal.fire({
                icon: 'success',
                title: 'Detalles enviados a impresión.',
                showConfirmButton: false,
                timer: 1500
            });
        } catch (error) {
            console.error('Error al imprimir los detalles:', error);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: error.message || 'Ocurrió un error al imprimir los detalles.'
            });
        }
    };

    // Función para validar múltiples detalles seleccionados
    const handleValidarMultiple = async () => {
        if (selectedDetalles.length === 0) {
            Swal.fire({
                text: "Por favor, selecciona al menos un detalle.",
                icon: "warning",
            });
            return;
        }

        // Ejemplo: exigir que todos estén en 1 (prevalidado) antes de validarlos
        const algunoNoPrevalidado = selectedDetalles.some(d => d.idTipoAprobacion !== 2);
        if (algunoNoPrevalidado) {
            Swal.fire(
                "Error",
                "Todos los exámenes a validar deben estar en prevalidado (idTipoAprobacion=1).",
                "error"
            );
            return;
        }

        Swal.fire({
            title: "¿Está seguro?",
            text: "¿Desea validar los detalles seleccionados?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, Validar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Ejecutar la validación de cada detalle seleccionado en paralelo
                    await Promise.all(selectedDetalles.map(detalle => ejecutarValidarDetalle(detalle)));
                    Swal.fire("Validados", "Los detalles han sido validados.", "success");
                    // Opcionalmente, puedes actualizar el estado de la lista (por ejemplo, removiendo los validados)
                    await refreshDetalles();
                    setSelectedDetalles([]);
                } catch (error) {
                    console.error(error);
                    Swal.fire("Error", error.message, "error");
                }
            }
        });
    };

    // Función auxiliar que valida un detalle individual y retorna una promesa
    const ejecutarValidarDetalle = async (detalle) => {
        const camposDeseados = [
            "idDetalle",
            "descripcionTipoAnalisis",
            "valorVenta",
            "comentarios",
            "idEquipo",
            "ingresadoPor",
            "idFactura",
            "idMetodo",
            "idModulo",
            "idOrdenMedica",
            "idTipoAnalisis",
            "idTipoPrecio",
            "valorDescuento",
            "evaluada"
        ];

        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 3,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        // Actualizar el detalle
        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData),
        });
        if (!response.ok) {
            throw new Error(`Error al validar el detalle ${detalle.idDetalle}`);
        }

        // Insertar en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobacion: new Date().toISOString().slice(0, -1),
            idTipoAprobacion: 2,
            idOrdenMedicaDetalle: detalle.idDetalle,
        };
        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData),
        });
        if (!histResponse.ok) {
            throw new Error(`Error al insertar en el histórico para el detalle ${detalle.idDetalle}`);
        }
        return updateData;
    };

    // Función auxiliar para invalidar un detalle individual
    const ejecutarInvalidarDetalle = async (detalle) => {
        const camposDeseados = [
            "descripcionTipoAnalisis",
            "valorVenta",
            "comentarios",
            "idEquipo",
            "idFactura",
            "idMetodo",
            "idModulo",
            "idOrdenMedica",
            "idPromocion",
            "idTipoAnalisis",
            "idTipoPrecio",
            "valorDescuento",
            "evaluada",
            "comentarios",
            "IngresadoPor"
        ];

        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            // Volvemos a prevalidado: tipoValidacion = 1
            idTipoAprobacion: 1,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString(),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        // Actualizar el detalle
        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData),
        });
        if (!response.ok) {
            throw new Error(`No se pudo actualizar el detalle ${detalle.idDetalle}`);
        }

        // Insertar el registro en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobacion: new Date().toISOString(),
            idTipoAprobacion: 1,
            idOrdenMedicaDetalle: detalle.idDetalle,
        };

        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData),
        });
        if (!histResponse.ok) {
            throw new Error(`No se pudo insertar en el histórico para el detalle ${detalle.idDetalle}`);
        }
        return updateData;
    };

    // Función para invalidar múltiples detalles seleccionados
    const handleInvalidarMultiple = async () => {
        if (selectedDetalles.length === 0) {
            Swal.fire({
                text: "Por favor, selecciona al menos un examen.",
                icon: "warning",
            });
            return;
        }

        // Ejemplo: exigir que todos estén validados (2) antes de invalidar
        const algunoNoValidado = selectedDetalles.some(d => d.idTipoAprobacion !== 3);
        if (algunoNoValidado) {
            Swal.fire(
                "Error",
                "Todos los exámenes a invalidar deben estar en validado",
                "error"
            );
            return;
        }

        Swal.fire({
            title: "¿Está seguro?",
            text: "¿Desea invalidar los detalles seleccionados? Esto los revertirá a prevalidado.",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, Invalidar",
            cancelButtonText: "Cancelar",
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await Promise.all(selectedDetalles.map(detalle => ejecutarPrevalidarDetalle(detalle)));
                    Swal.fire("Invalidados", "Los detalles han sido invalidados.", "success");
                    await refreshDetalles();
                    // Opcional: limpiar la selección
                    setSelectedDetalles([]);
                } catch (error) {
                    console.error(error);
                    Swal.fire("Error", error.message, "error");
                }
            }
        });
    };

    // Función para recargar los detalles de la orden seleccionada
    const refreshDetalles = async () => {
        if (selectedOrdenTrabajo) {
            try {
                const response = await fetch(
                    `${server}/MgOrdenesMedicasDetalles/idOrdenTrabajo/${selectedOrdenTrabajo.idOrdenMedica}`
                );
                if (response.ok) {
                    const data = await response.json();
                    setDetallesOrdenTrabajo(data.$values || []);
                } else {
                    console.error('Error al recargar los detalles de la orden de trabajo');
                }
            } catch (error) {
                console.error('Error al recargar los detalles:', error);
            }
        }
    };

    // Función auxiliar para quitar la prevalidación de un detalle individual
    const ejecutarQuitarPrevalidarDetalle = async (detalle) => {
        const camposDeseados = [
            "idDetalle",
            "descripcionTipoAnalisis",
            "valorVenta",
            "comentarios",
            "idEquipo",
            "ingresadoPor",
            "idFactura",
            "idMetodo",
            "idModulo",
            "idOrdenMedica",
            "idTipoAnalisis",
            "idTipoPrecio",
            "idTipoAnalisis",
            "valorDescuento",
            "valorVenta",
            "evaluada",
            "comentarios"
        ];

        const updateData = {
            ...pickDetailFields(detalle, camposDeseados),
            idTipoAprobacion: 1,
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobado: new Date().toISOString().slice(0, -1),
            modificadoPor: user ? user.codigoUsuario : "ADMIN",
        };

        // Actualizamos el detalle
        const response = await fetch(`${server}/MgOrdenesMedicasDetalles/${detalle.idDetalle}`, {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(updateData)
        });

        if (!response.ok) {
            throw new Error(`No se pudo actualizar el detalle ${detalle.idDetalle}`);
        }

        // Insertamos en el histórico
        const histData = {
            ingresadoPor: user ? user.codigoUsuario : "ADMIN",
            aprobadoPor: user ? user.codigoUsuario : "ADMIN",
            fechaHoraAprobacion: new Date().toISOString(),
            idTipoAprobacion: null,
            idOrdenMedicaDetalle: detalle.idDetalle
        };

        const histResponse = await fetch(`${server}/MgHistoricoValidaciones`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(histData)
        });

        if (!histResponse.ok) {
            throw new Error(`No se pudo insertar en el histórico para el detalle ${detalle.idDetalle}`);
        }

        return updateData;
    };

    // Función para quitar la prevalidación de múltiples detalles seleccionados
    const handleQuitarPrevalidarMultiple = async () => {
        if (selectedDetalles.length === 0) {
            Swal.fire({
                text: "Por favor, selecciona al menos un examen.",
                icon: "warning"
            });
            return;
        }

        // Verificar si todos son prevalidados (1), 
        // pues si alguno está en 2, no se puede quitar la prevalidación.
        const algunoValidado = selectedDetalles.some(d => d.idTipoAprobacion === 3);
        if (algunoValidado) {
            Swal.fire(
                "Error",
                "No se puede quitar la prevalidación de un examen que ya está validado.",
                "error"
            );
            return;
        }

        Swal.fire({
            title: "¿Está seguro?",
            text: "¿Desea quitar la prevalidación de los exámenes seleccionados?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Sí, quitar prevalidación",
            cancelButtonText: "Cancelar"
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    // Ejecuta la operación en paralelo para todos los detalles seleccionados
                    await Promise.all(selectedDetalles.map(detalle => ejecutarQuitarPrevalidarDetalle(detalle)));
                    Swal.fire("Quitado", "La prevalidación ha sido removida de los detalles seleccionados.", "success");
                    await refreshDetalles();
                    // Limpia la selección o actualiza los detalles según sea necesario
                    setSelectedDetalles([]);
                    // Opcional: Recargar los detalles actualizados (si tienes función refreshDetalles)
                    // await refreshDetalles();
                } catch (error) {
                    console.error(error);
                    Swal.fire("Error", error.message, "error");
                }
            }
        });
    };



    return (
        <>
        <div className="right_col" role="main">
            <div className="x_title"></div>
            <div className="x_content">
                <h2>Listado de Ordenes de Trabajo</h2>
                <br />
                {/* <div className="row"> */}
                    {/* <div className="col-md-9 col-sm-4 offset-md-2"> */}
                        <Grid container spacing={2} alignItems="center" style={{ marginBottom: '20px' }}>
                            {/* Autocomplete sucursal */}
                            <Grid item xs={12} md={3}>
                                <Autocomplete
                                    options={sucursales}
                                    getOptionLabel={(option) => option.nombreSucursal || ''}
                                    value={typeof sucursalFiltro === 'object' ? sucursalFiltro : null}
                                    onChange={handleSucursalSeleccionada}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Sucursal" variant="outlined" fullWidth />
                                    )}
                                />
                            </Grid>

                            <Grid item xs={12} md={3}>
                                <Autocomplete
                                    options={modulos}
                                    getOptionLabel={(option) => option.nombreModulo || ''}
                                    value={selectedModulo}
                                    onChange={(event, newValue) => setSelectedModulo(newValue)}
                                    renderInput={(params) => (
                                        <TextField {...params} label="Módulo" variant="outlined" fullWidth />
                                    )}
                                />
                            </Grid>

                            { /* Fechas */}
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Fecha Inicio"
                                    type="date"
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={fechaInicio}
                                    onChange={handleFechaInicioChange}
                                />
                            </Grid>
                            <Grid item xs={12} md={3}>
                                <TextField
                                    label="Fecha Fin"
                                    type="date"
                                    variant="outlined"
                                    fullWidth
                                    InputLabelProps={{ shrink: true }}
                                    value={fechaFin}
                                    onChange={handleFechaFinChange}
                                />
                            </Grid>
                            <Grid item xs={10}>
                                <TextField
                                    variant="outlined"
                                    label="Buscar Orden de Trabajo"
                                    fullWidth
                                    value={searchQuery}
                                    onChange={handleSearchChange}
                                    onKeyDown={handleKeyDown}
                                />
                            </Grid>
                            <Grid item xs={2}>
                                <Button variant="contained" color="primary" onClick={handleSearch}>
                                    Buscar
                                </Button>
                            </Grid>
                        </Grid>
                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Button variant="contained" color="primary" onClick={handleFactura} disabled={!tienePermiso('Facturar OT Hospital')} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Factura
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleImprimirSobre} disabled={!tienePermiso('Imprimir Sobre Hospital')} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Sobre
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleImprimir} disabled={!tienePermiso('Reimprimir OT Hospital')} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Reimprimir
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleImprimir} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Correo
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleWhatsapp} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    WhatsApp
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleVerCompleto} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Ver Completo
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleResultados} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Resultados
                                </Button>

                            </Grid>
                        </Grid>
                        {loading ? (
                            <div style={{ textAlign: 'center', marginTop: '20px' }}>
                                <CircularProgress />
                            </div>
                        ) : (
                            <TableContainer component={Paper} style={{ marginTop: '20px' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell sx={{ fontWeight: 'bold' }}> </TableCell>
                                            <TableCell style={{ fontWeight: 'bold', minWidth: '100px' }}>Fecha</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>N° Orden</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', minWidth: '300px' }}>Nombre Cliente</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Sub Total</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Descuento</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Total</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', minWidth: '180px' }}>Estado</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Entreg.</TableCell>
                                            <TableCell sx={{ fontWeight: 'bold' }}>Medio Entrega</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', minWidth: '200px' }}>Origen</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', minWidth: '200px' }}>Medico</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', minWidth: '200px' }}>Fecha Recepcion</TableCell>
                                            <TableCell style={{ fontWeight: 'bold', minWidth: '200px' }}>Fecha Entrega</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paginatedOrdenesTrabajo.map((ordenTrabajo) => (
                                            <TableRow key={ordenTrabajo.idOrdenMedica}>
                                                <TableCell style={{ padding: '4px' }}>
                                                    <Checkbox
                                                        checked={selectedOrdenTrabajo?.idOrdenMedica === ordenTrabajo.idOrdenMedica}
                                                        onChange={() => handleSelectOrdenTrabajo(ordenTrabajo)}
                                                    />
                                                </TableCell >
                                                <TableCell style={{ padding: '4px' }}>{dayjs(ordenTrabajo.fechaOrdenMedica).format('DD/MM/YYYY')}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>PR{ordenTrabajo.idOrdenMedicaMes}</TableCell>
                                                <TableCell style={{ padding: '4px' }} >{ordenTrabajo.nombreCompleto}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{(Number(ordenTrabajo.valorVenta) + Number(ordenTrabajo.valorDescuento)).toFixed(2)}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{(ordenTrabajo.valorDescuento).toFixed(2)}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{(ordenTrabajo.valorVenta).toFixed(2)}</TableCell>
                                                <TableCell style={{ padding: '4px' }}> {ordenTrabajo.modificacion === 1 ? "Pendiente" : ordenTrabajo.descripcionModificacion}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{ordenTrabajo.entregado ? 'Si' : 'No'}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>
                                                    {ordenTrabajo.enviarXWhatsapp && <FontAwesomeIcon icon={faWhatsapp} title="WhatsApp" style={{ margin: '0 2px' }} />}
                                                    {ordenTrabajo.enviarXApp && <FontAwesomeIcon icon={faMobileAlt} title="App" style={{ margin: '0 2px' }} />}
                                                    {ordenTrabajo.enviarXCorreo && <FontAwesomeIcon icon={faEnvelope} title="Email" style={{ margin: '0 2px' }} />}
                                                    {ordenTrabajo.imprimir && <FontAwesomeIcon icon={faPrint} title="Impreso" style={{ margin: '0 2px' }} />}
                                                    {!ordenTrabajo.enviarXWhatsapp && !ordenTrabajo.enviarXApp && !ordenTrabajo.enviarXCorreo && !ordenTrabajo.imprimir && 'N/A'}
                                                </TableCell>
                                                <TableCell style={{ padding: '4px' }}>{ordenTrabajo.origen ? ordenTrabajo.origen : 'N/A'}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{ordenTrabajo.nombreMedico ? ordenTrabajo.nombreMedico : 'N/A'}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{dayjs(ordenTrabajo.fechaRecepcion).format('DD/MM/YYYY hh:mm:ss A')}</TableCell>
                                                <TableCell style={{ padding: '4px' }}>{dayjs(ordenTrabajo.fechaEntrega).format('DD/MM/YYYY hh:mm:ss A')}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>

                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={totalOrdenesTrabajo}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    labelRowsPerPage="Filas por página:"
                                    labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count !== -1 ? count : `más de ${to}`}`}
                                />
                            </TableContainer>
                        )}

                        <Grid container spacing={2}>
                            <Grid item xs={12}>
                                <Button variant="contained" color="primary" onClick={handleModificar} disabled={!tienePermiso('Modificar OT Hospital')} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Modificar
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleDividir} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Dividir Orden
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleAtendida} disabled={!tienePermiso('Marcar Atendida Hospital')} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Atendida
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleEntregada} disabled={!tienePermiso('Marcar Entregada Hospital')} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Entregada
                                </Button>
                                <Button variant="contained" color="primary" onClick={handleAnular} disabled={!tienePermiso('Reactivar OT Hospital')} style={{ marginLeft: '5px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                    Anular
                                </Button>
                            </Grid>
                        </Grid>

                        {selectedOrdenTrabajo && (
                            <>

                                <h3>Detalles de la Orden de Trabajo</h3>
                                <Grid container spacing={2}>
                                    <Grid item xs={12}>
                                        {/* <Button variant="contained" color="primary" onClick={handleResultados}>
                                                                        Resultados
                                                                    </Button> */}
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2}>

                                    <Grid item xs={10} sx={{ mx: 'auto' }}> {/* Esto centra horizontalmente el Grid */}
                                        {detallesOrdenTrabajo.length > 0 ? (
                                            <TableContainer component={Paper} sx={{ mt: 2 }}>
                                                <Table>
                                                    <TableHead>
                                                        <TableRow>
                                                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Seleccionar</TableCell>
                                                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Descripción</TableCell>
                                                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Tipo Precio</TableCell>
                                                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Total</TableCell>
                                                            <TableCell align="center" sx={{ fontWeight: 'bold' }}>Estado</TableCell>
                                                            {/* Agrega más columnas según sea necesario */}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {detallesOrdenTrabajo.map((detalle) => {
                                                            // Buscar el detalle en el arreglo "detallesOrdenTrabajoInfo" que contiene las muestras
                                                            const detalleConMuestras = detallesOrdenTrabajoInfo.find(
                                                                (info) => info.idDetalle === detalle.idDetalle
                                                            );

                                                            // Verificar que exista el arreglo de muestras y que tenga registros
                                                            const tieneMuestras =
                                                                detalleConMuestras &&
                                                                detalleConMuestras.muestrasTomadas &&
                                                                Array.isArray(detalleConMuestras.muestrasTomadas.$values) &&
                                                                detalleConMuestras.muestrasTomadas.$values.length > 0;

                                                            // Validar que en cada registro de muestras, el campo id_estado sea distinto a 1
                                                            const todasMuestrasValidas =
                                                                tieneMuestras &&
                                                                detalleConMuestras.muestrasTomadas.$values.every(
                                                                    (muestra) => muestra.id_estado !== 1
                                                                );

                                                            // Si todas las muestras cumplen la condición, pintamos la fila de verde
                                                            const rowStyle = todasMuestrasValidas ? { backgroundColor: 'lightgreen' } : {};

                                                            return (
                                                                <TableRow key={detalle.idDetalle} style={rowStyle}>
                                                                    <TableCell align="center">
                                                                        <Checkbox
                                                                            checked={selectedDetalles.some(d => d.idDetalle === detalle.idDetalle)}
                                                                            onChange={() => toggleDetalleSelection(detalle)}
                                                                        />
                                                                    </TableCell>
                                                                    <TableCell align="right">{detalle.descripcionTipoAnalisis}</TableCell>
                                                                    <TableCell align="center">{detalle.descripcionTipoPrecio}</TableCell>
                                                                    <TableCell align="center">{detalle.valorVenta}</TableCell>
                                                                    <TableCell align="center">{detalle.tipoValidacion}</TableCell>
                                                                </TableRow>
                                                            );
                                                        })}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        ) : (
                                            <p>No hay detalles disponibles para esta orden de trabajo.</p>
                                        )}
                                    </Grid>

                                    <Grid item xs={2}>
                                        <Grid container spacing={2}>
                                            <Grid item xs={12}>
                                                <Button variant="contained" color="primary" onClick={handlePrevalidarMultiple} style={{ marginLeft: '10px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                                    Prevalidar
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button variant="contained" color="primary" onClick={handleQuitarPrevalidarMultiple} style={{ marginLeft: '10px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                                    Quitar PreV.
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button variant="contained" color="primary" onClick={handleValidarMultiple} style={{ marginLeft: '10px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                                    Validar
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button variant="contained" color="primary" onClick={handleInvalidarMultiple} style={{ marginLeft: '10px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                                    Invalidar
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button variant="contained" color="primary" onClick={handleImprimirDetalles} disabled={!tienePermiso('Imprimir Etiqueta Hospital')} style={{ marginLeft: '10px' }} sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}>
                                                    Imprimir
                                                </Button>
                                            </Grid>
                                            <Grid item xs={12}>
                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    sx={{ minWidth: '80px', padding: '4px 8px', fontSize: '0.75rem' }}
                                                    onClick={() => {
                                                        // Por ejemplo, si ya tienes la orden seleccionada:
                                                        if (selectedOrdenTrabajo) {
                                                            // Asigna el id del análisis que deseas mostrar (puede venir de alguna lógica o selección previa)

                                                            setOpenTomaMuestra(true);
                                                        } else {
                                                            Swal.fire({ text: 'Primero debes seleccionar una orden de trabajo.', icon: 'warning' });
                                                        }
                                                    }}
                                                >
                                                    Toma Muestra
                                                </Button>

                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </>
                        )}


                        <Modal
                            open={openModal}
                            onClose={() => setOpenModal(false)}
                            aria-labelledby="modal-title"
                            aria-describedby="modal-description"
                        >
                            <div style={modalStyle}>
                                {ordenTrabajoData && (
                                    <GestionOrdenTrabajo
                                        ordenTrabajo={ordenTrabajoData.OrdenTrabajo}
                                        modo={ordenTrabajoData.modo} // Pasamos el modo
                                        onClose={() => {
                                            setOpenModal(false);
                                            // Opcional: Recargar la lista de ordenes si se han hecho cambios
                                            fetchOrdenesTrabajos(searchQuery);
                                        }}
                                    />
                                )}
                            </div>
                        </Modal>
                        <Modal
                            open={openFacturaModal}
                            onClose={() => setOpenFacturaModal(false)}
                            aria-labelledby="modal-title-factura"
                            aria-describedby="modal-description-factura"
                        >
                            <div style={modalStyle}>
                                {facturaData && (
                                    <GestionFactura
                                        datosFactura={facturaData}
                                        onClose={() => setOpenFacturaModal(false)}
                                    />
                                )}
                            </div>
                        </Modal>

                        <Modal
                            open={openResultadosModal}
                            onClose={() => setOpenResultadosModal(false)}
                            aria-labelledby="modal-title-resultados"
                            aria-describedby="modal-description-resultados"
                        >
                            <div style={modalStyle}>
                                {numericCodigo && (
                                    <Resultados
                                        open={openResultadosModal}
                                        handleClose={() => setOpenResultadosModal(false)}
                                        OrdenTrabajo={numericCodigo}
                                    />
                                )}
                            </div>
                        </Modal>

                        <Modal open={openTomaMuestra} onClose={() => setOpenTomaMuestra(false)}>
                            <Box sx={{
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: '80%',
                                maxHeight: '90vh',
                                overflowY: 'auto',
                                backgroundColor: 'white',
                                padding: '20px',
                                borderRadius: '8px'
                            }}>
                                <TomaMuestra
                                    selectedOrden={selectedOrdenTrabajo ? selectedOrdenTrabajo : ""}
                                    selectedAnalisisId={detalleSeleccionado ? detalleSeleccionado.idTipoAnalisis : ""}
                                    open={openTomaMuestra}
                                    onClose={() => setOpenTomaMuestra(false)}
                                />
                            </Box>
                        </Modal>


                    {/* </div> */}
                {/* </div> */}
            </div>
            </div>
        </>
    );
}

export default OrdenesTrabajoHospital;
